import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/health/page.tsx");
